import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const Immigration = () => {
  const [activeTab, setActiveTab] = useState('us');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Global Immigration & Citizenship Programs" 
      subtitle="Comprehensive immigration solutions providing pathways to citizenship, residency, and global mobility"
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Investment-Based Immigration</h2>
            <p>
              Through strategic investment programs worldwide, we provide comprehensive pathways 
              to citizenship and residency, offering our clients global mobility and new opportunities.
            </p>
          </div>
          
          <div className="tab-navigation">
            <button 
              className={`tab-btn ${activeTab === 'us' ? 'active' : ''}`}
              onClick={() => handleTabChange('us')}
            >
              <img src="https://flagcdn.com/w20/us.png" alt="US" className="flag-icon" />
              EB-5 USA
            </button>
            <button 
              className={`tab-btn ${activeTab === 'stkitts' ? 'active' : ''}`}
              onClick={() => handleTabChange('stkitts')}
            >
              <img src="https://flagcdn.com/w20/kn.png" alt="St. Kitts" className="flag-icon" />
              St. Kitts & Nevis
            </button>
            <button 
              className={`tab-btn ${activeTab === 'vanuatu' ? 'active' : ''}`}
              onClick={() => handleTabChange('vanuatu')}
            >
              <img src="https://flagcdn.com/w20/vu.png" alt="Vanuatu" className="flag-icon" />
              Vanuatu
            </button>
          </div>

          {/* US EB-5 Tab Content */}
          {activeTab === 'us' && (
            <div className="tab-content">
              <div className="immigration-service-card">
                <div className="service-header">
                  <img src="https://flagcdn.com/w40/us.png" alt="US Flag" className="service-flag" />
                  <h3>EB-5 Immigrant Investor Program</h3>
                </div>
                <div className="service-content">
                  <div className="service-text">
                    <p>
                      The EB-5 Immigrant Investor Program allows eligible investors and their families 
                      to obtain U.S. Green Cards by investing in a U.S. business that creates at least 
                      10 full-time jobs for U.S. workers.
                    </p>
                    
                    <div className="info-section">
                      <h4>Investment Requirements</h4>
                      <ul>
                        <li>$1,050,000 USD – Standard investment</li>
                        <li>$800,000 USD – Targeted Employment Area (TEA)</li>
                        <li>Create or preserve at least 10 full-time jobs</li>
                      </ul>
                    </div>
                    
                    <div className="info-section">
                      <h4>Investment Options</h4>
                      <ul>
                        <li>Direct Investment (own and operate your business)</li>
                        <li>Regional Center Investment (through USCIS-approved center)</li>
                      </ul>
                    </div>
                  </div>
                  <div className="service-image">
                    <img 
                      src="https://images.unsplash.com/photo-1508433957232-3107f5fd5995?q=80&w=2086&auto=format&fit=crop&ixlib=rb-4.1.0" 
                      alt="US Investment" 
                      onClick={() => openLightbox('https://images.unsplash.com/photo-1508433957232-3107f5fd5995?q=80&w=2086&auto=format&fit=crop&ixlib=rb-4.1.0', 'US Investment')}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* St. Kitts Tab Content */}
          {activeTab === 'stkitts' && (
            <div className="tab-content">
              <div className="immigration-service-card">
                <div className="service-header">
                  <img src="https://flagcdn.com/w40/kn.png" alt="St. Kitts Flag" className="service-flag" />
                  <h3>St. Kitts and Nevis Citizenship by Investment</h3>
                </div>
                <div className="service-content">
                  <div className="service-text">
                    <p>
                      Established in 1984, the St. Kitts and Nevis CBI Program is the oldest and most 
                      trusted citizenship by investment program in the world.
                    </p>
                    
                    <div className="info-section">
                      <h4>Investment Options</h4>
                      <ul>
                        <li>Sustainable Island State Contribution - From $250,000</li>
                        <li>Real Estate Investment - Minimum $400,000</li>
                        <li>Public Benefit Option - Minimum $250,000</li>
                      </ul>
                    </div>
                    
                    <div className="info-section">
                      <h4>Key Benefits</h4>
                      <ul>
                        <li>Visa-free access to 150+ countries</li>
                        <li>No personal income tax</li>
                        <li>Dual citizenship permitted</li>
                        <li>Processing time: 3-6 months</li>
                      </ul>
                    </div>
                  </div>
                  <div className="service-image">
                    <img 
                      src="https://images.unsplash.com/photo-1633107782766-bd7c8507ce41?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0" 
                      alt="St. Kitts" 
                      onClick={() => openLightbox('https://images.unsplash.com/photo-1633107782766-bd7c8507ce41?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0', 'St. Kitts')}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Vanuatu Tab Content */}
          {activeTab === 'vanuatu' && (
            <div className="tab-content">
              <div className="immigration-service-card">
                <div className="service-header">
                  <img src="https://flagcdn.com/w40/vu.png" alt="Vanuatu Flag" className="service-flag" />
                  <h3>Republic of Vanuatu Citizenship</h3>
                </div>
                <div className="service-content">
                  <div className="service-text">
                    <p>
                      The Vanuatu Citizenship by Investment Program offers one of the fastest and most 
                      straightforward second citizenship solutions in the world.
                    </p>
                    
                    <div className="info-section">
                      <h4>Investment Requirements</h4>
                      <ul>
                        <li>Single applicant: $130,000 USD</li>
                        <li>Married couple: $150,000 USD</li>
                        <li>Family of 4: $180,000–200,000 USD</li>
                      </ul>
                    </div>
                    
                    <div className="info-section">
                      <h4>Key Benefits</h4>
                      <ul>
                        <li>Fast processing: 60 days approval</li>
                        <li>No personal income tax</li>
                        <li>Visa-free access to 100+ countries</li>
                        <li>No residency requirements</li>
                      </ul>
                    </div>
                  </div>
                  <div className="service-image">
                    <img 
                      src="https://images.unsplash.com/photo-1720041802374-db32d4263016?q=80&w=2076&auto=format&fit=crop&ixlib=rb-4.1.0" 
                      alt="Vanuatu" 
                      onClick={() => openLightbox('https://images.unsplash.com/photo-1720041802374-db32d4263016?q=80&w=2076&auto=format&fit=crop&ixlib=rb-4.1.0', 'Vanuatu')}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="immigration-page-cta-section">
            <h3>Start Your Immigration Journey</h3>
            <p>Ready to explore global citizenship opportunities? Contact our immigration specialists.</p>
            <a href="/contact" className="btn immigration-btn-primary">Get Started</a>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default Immigration;